import React from 'react'
import { useHistory } from 'react-router-dom'

import { exitImpersonation } from 'ImpersonateHint'
import { LOGIN_PATH } from 'account/login/Login'
import { Dropdown, Menu } from 'antd'

import localStorage from 'core/application/commons/localStorage'

import Icon from 'common/components/general/Icon'

import useCurrentProduct from 'common/hooks/useCurrentProduct'
import useLoginUser from 'common/hooks/useLoginUser'

import { useSharedState } from 'common/hooks'

import PeopleKeepLogoMobile from 'assets/images/people-keep-benefits-personalized-mobile.png'
import PeopleKeepLogo from 'assets/images/people-keep-benefits-personalized.svg'

import SignInIcon from '../../../assets/images/icons/sign-in.svg'
import Avatar from '../dataDisplay/Avatar'
import Button from '../general/Button'

import './HeaderStyles.less'

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  let history = useHistory()
  const [user] = useLoginUser()
  const product = useCurrentProduct()
  const [, setHideExpensesSmsUpdates] = useSharedState<boolean>('HideExpensesSmsUpdates', false, true)
  const logout = () => {
    if (localStorage.getImpersonatorToken()) {
      exitImpersonation()
    } else {
      localStorage.setToken('')
      localStorage.setImpersonatorToken('')
      localStorage.setSearchedCompanyId('')
      localStorage.setSearchedCompanyName('')
      setHideExpensesSmsUpdates(false)
      localStorage.setDismissedRenewalNotification(false)
      history.push(LOGIN_PATH)
    }
  }

  const menu = (
    <Menu>
      <Menu.Item key="2" onClick={logout}>
        <Icon type="logout" />
        <span>Log out</span>
      </Menu.Item>
    </Menu>
  )

  let firstName = user.firstName
  let lastName = user.lastName

  let rightSection = user ? (
    <>
      <Avatar shape="circle" size="default" text={firstName[0] + lastName[0]} className="pk--header-user-icon" />
      <Dropdown overlay={menu} trigger={['hover']} placement="bottomLeft">
        <a className="ant-dropdown-link grey-link ml-8 personal-dropdown" onClick={(e) => e.preventDefault()}>
          {firstName[0]}. {lastName}
          <Icon type="down" className="ml-8" />
        </a>
      </Dropdown>
    </>
  ) : (
    <Button type="primary" size="large">
      <section className="pk--header-signin">
        <img src={SignInIcon} alt="" />
        Sign in
      </section>
    </Button>
  )

  return (
    <header className="pk--header">
      <section className="pk--header-logo">
        <a href="#">
          <img src={PeopleKeepLogo} alt="PeopleKeep Logo" className="pk--header-logo--desktop" />
          <img src={PeopleKeepLogoMobile} alt="PeopleKeep Logo" className="pk--header-logo--mobile" />
        </a>
        <span className="pk--header-divider"></span>
        {product && <img src={product.productLogo} alt="Logo" />}
      </section>
      <section className="pk--header-right-section">{rightSection}</section>
    </header>
  )
}

export default Header
